export default "__VITE_ASSET__soncA_rt__"